<template>
  <MainLayout section="txs">
    <b-container fluid id="txs-container" v-bind:class="$mq">
      <b-row no-gutters id="txs_header" class="mb-2" v-bind:class="$mq">
        <b-col>
          <b>Transaction:</b>
          <span id="tx_id">
            {{ tx_id }}
          </span>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-radio v-model="format"
                        value="formatted"
                        button
                        button-variant="light"
                        class="format_radio">
            Formatted
          </b-form-radio>

          <b-form-radio v-model="format"
                        value="raw"
                        button
                        button-variant="light"
                        class="format_radio">
            Raw
          </b-form-radio>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
            <div class="spinner_container"  v-if="loading">
              <b-spinner />
            </div>
        </b-col>
      </b-row>

      <b-row no-gutters>
        <b-col cols="12">
          <div v-if="format=='formatted'" id="formatted_tx">
            <RenderedTx  v-bind:tx="$store.state.tx"/>
          </div>

          <div v-else id="raw_tx">
            <pre>{{JSON.stringify($store.state.tx, null, 2)}}</pre>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout from './components/MainLayout.vue'
import RenderedTx from './components/RenderedTx.vue'

var CommandDispatcher = require('./mixins/command_dispatcher')
import config from './config'

function get_tx(vue, tx_id){
  var cmd = {
    'command'     : 'tx',
    'transaction' :  tx_id,
  };

  vue.loading = true;
  vue.sendCmd(cmd, function(tx){
    //vue.tx_id = ledger.ledger["ledger_index"];
    vue.$store.commit('set_tx', tx);
    vue.loading = false;
  });
}

// copy url-set params to store
function set_params(vue){
  vue.tx_id = vue.itx_id;
}

export default {
  name: 'Txs',

  mixins : [CommandDispatcher],

  components: {
    MainLayout,
    RenderedTx
  },

  props : {
    itx_id : String
  },

  data : function(){
    return {
       config : config,
      loading : true,
       format : 'formatted'
    };
  },

  computed : {
    tx_id : {
      get : function(){
        return this.$store.state.tx_id || null;
      },

      set : function(i){
        this.$store.commit('set_tx_id', i);
      }
    }
  },

  watch : {
   '$route' : function(){
     set_params(this);

     // TODO: only if different
     get_tx(this, this.tx_id);
   }
  },

  created : function(){
    set_params(this);

    this.$store.commit('clear_tx');

    this.$store.commit('on_open_socket', function(){
      var specified = this.tx_id;
      get_tx(this, specified);
    }.bind(this));
  }
}
</script>

<style scoped>
#txs-container{
  flex-grow: 1;
  padding: 25px;
  margin: 0;
  background: #eef1f6;
}

#txs-container.sm{
  margin-top: 5px;
}

#txs_header{
  background-color: white;
  padding: 10px;
  border: 1px solid #cccccc;
  font-size: 0.8rem;
  overflow: hide;
}

#txs_header.sm{
  font-size: 1.2em;
}

#tx_id {
  font-weight: bold;
  color: blue;
  cursor: pointer;
  word-wrap: anywhere;
}

.format_radio{
  width: 50%;
}

.format_radio >>> .btn{
  width: 100%;
  border-radius: 0;
}

#formatted_tx{
  overflow: hidden;
}

#raw_tx{
  overflow: auto;
  background-color: white;
  padding: 15px;
}
</style>
